<template>
    <div class="course-detail-container">
        <headerPage></headerPage>

        <!-- 返回按钮 -->
        <div class="course-back-wrapper">
            <el-button @click="goBack()" type="text" icon="el-icon-arrow-left" class="course-back-button">
                返回
            </el-button>
        </div>

        <!-- 课程详情信息区域 -->
        <div class="course-info-wrapper">
            <div class="course-cover">
                <img :src="courseInfo.imageUrl" alt="课程封面" class="cover-image" />
            </div>

            <div class="course-info">
                <h1 class="course-title">{{ courseInfo.title }}</h1>

                <!-- 评分和评价区域 -->
                <div class="course-rating">
                    <!-- 使用 el-rate 显示评分 -->
                    <el-rate v-model="courseInfo.rating" disabled show-score text-color="#ff9900"
                        score-template="{value}" class="rating"></el-rate>

                    <!-- 评价数量 -->
                    <span class="review-count">（共 {{ courseInfo.reviews }} 条评价）</span>
                </div>
            </div>
        </div>

        <!-- 章节和模拟考试选项按钮 -->
        <div class="chapter-header tabs">
            <el-button :type="activeTab === 'course-chapters' ? 'primary' : 'default'"
                @click="setActiveTab('course-chapters')">章节练习</el-button>
            <el-button :type="activeTab === 'mock-exam' ? 'primary' : 'default'"
                @click="setActiveTab('mock-exam')">模拟考试</el-button>
        </div>

        <!-- 根据选中的选项卡显示章节列表 -->
        <div v-if="activeTab === 'course-chapters'">
            <div class="chapter-section">
                <el-row :gutter="20" class="chapter-list">
                    <el-col :xs="24" v-for="(chapter, index) in chapterList" :key="index" class="chapter-col">
                        <el-card class="chapter-card" shadow="hover">
                            <div class="chapter-content">
                                <h3 class="chapter-title">{{ chapter.chapterTitle }}</h3>
                                <div class="chapter-actions">
                                    <span class="chapter-status">{{ chapter.progress }}% 完成度</span>
                                    <el-button type="waring" size="small" class="start-btn"
                                        @click="startWrong(chapter.id)">
                                        错题再练
                                    </el-button>
                                    <el-button type="primary" size="small" class="start-btn"
                                        @click="startQuiz(chapter.id)">
                                        开始答题
                                    </el-button>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
            </div>
        </div>

        <div v-if="activeTab === 'mock-exam'">
            <div class="mock-exam-section">
                <el-row :gutter="20" class="chapter-list">
                    <el-col :xs="24" v-for="(exam, index) in mockExamList" :key="index" class="chapter-col">
                        <el-card class="chapter-card" shadow="hover">
                            <div class="chapter-content">
                                <h3 class="chapter-title">{{ exam.examTitle }}</h3>
                                <div class="chapter-actions">
                                    <span class="chapter-status">{{ exam.questionCount }} 题 / {{ exam.score }} 总分</span>
                                    <el-button type="primary" size="small" class="start-btn"
                                        @click="startMockExam(exam.id)">
                                        开始模拟考试
                                    </el-button>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
            </div>
        </div>

        <bottomPage></bottomPage>
    </div>
</template>

<script>
import headerPage from "@/components/header/header";
import bottomPage from "@/components/bottom/bottom";
import * as CourseApi from "@/api/course";
import * as PaperApi from "@/api/paper";
import { MessageBox } from "element-ui";

export default {
    components: {
        headerPage,
        bottomPage,
    },
    data() {
        return {
            // 当前激活的选项卡
            activeTab: 'course-chapters',  // 默认选中课程章节

            // 课程基本信息
            courseInfo: {
                title: "",
                imageUrl: "",
                rating: 0,
                reviews: 0,
            },
            // 章节列表
            chapterList: [],
            // 模拟考试列表
            mockExamList: [],
        };
    },
    created() {
        this.fetchCourseInfo();
        this.fetchChapters();
        this.fetchQuiz();
    },
    methods: {
        async fetchCourseInfo() {
            try {
                const response = await CourseApi.getCourseById(this.$route.params.courseId);
                if (response.code === 0 && response.data) {
                    this.courseInfo.title = response.data.courseName;
                    this.courseInfo.imageUrl = response.data.courseImg;
                    this.courseInfo.rating = this.getRandomNumberInRange(4, 5, 2);
                    this.courseInfo.reviews = this.getRandomNumberInRange(1000, 3000, 0);
                }
            } catch (error) {
                console.error("获取课程基本信息失败：", error);
            }
        },
        async fetchChapters() {
            try {
                const response = await CourseApi.getCourseChapter(this.$route.params.courseId, this.$route.params.classId);
                if (response.code === 0 && response.data) {
                    this.chapterList = response.data.map(chapter => ({
                        id: chapter.id,
                        chapterTitle: chapter.chapterTitle,
                        isComplete: chapter.isComplete,
                        progress: this.calculateProgress(chapter.completePercent),
                    }));
                }
            } catch (error) {
                console.error("获取章节数据失败：", error);
            }
        },
        async fetchQuiz() {
            try {
                const response = await PaperApi.getAllQuizPaper(this.$route.params.courseId);
                if (response.code === 0 && response.data) {
                    this.mockExamList = response.data.map(paper => ({
                        id: paper.id,
                        examTitle: paper.paperName,
                        questionCount: paper.questionCount ? paper.questionCount : 0,
                        score: paper.score ? paper.score : 0,
                    }));
                }
            } catch (error) {
                console.error("获取试卷数据失败：", error);
            }
        },
        getRandomNumberInRange(min, max, decimalPlaces) {
            const random = Math.random() * (max - min) + min;
            return parseFloat(random.toFixed(decimalPlaces));
        },
        calculateProgress(completeTime) {
            return completeTime > 0 ? Math.min(100, completeTime / 100) : 0;
        },
        // 设置激活的选项卡
        setActiveTab(tab) {
            this.activeTab = tab;
        },
        // 开始答题按钮逻辑
        async startQuiz(chapterId) {
            const chapter = this.chapterList.find(c => c.id === chapterId);
            if (chapter && chapter.isComplete === 1) {
                try {
                    await MessageBox.confirm(
                        "该章节已完成，是否重新开始答题？这将覆盖原有进度。",
                        "提示",
                        {
                            confirmButtonText: "重新开始",
                            cancelButtonText: "取消",
                            type: "warning",
                        }
                    );
                    this.navigateToQuiz(chapterId, 0);
                } catch (err) {
                    // 用户点击了取消
                }
            } else {
                this.navigateToQuiz(chapterId, 0);
            }
        },
        // 错题再练
        async startWrong(chapterId) {
            const chapter = this.chapterList.find(c => c.id === chapterId);
            this.navigateToQuiz(chapterId, 1);
        },
        navigateToQuiz(chapterId, type) {
            this.$router.push({
                name: "chapterQuestion",
                params: {
                    classId: this.$route.params.classId,
                    courseId: this.$route.params.courseId,
                    chapterId: chapterId,
                    type: type,
                },
            });
        },
        // 开始模拟考试
        async startMockExam(id) {
            this.$router.push({
                name: "quiuzQuestion",
                params: {
                    paperId: id,
                },
            });
        },
        goBack() {
            this.$router.push("/myQuestionCourse");
        },
    },
};
</script>

<style scoped>
/* 页面容器样式 */
.course-detail-container {
    background-color: #f4f4f4;
    min-height: 100vh;
    padding: 20px;
}

.course-back-wrapper {
    max-width: 1200px;
    margin: 10px auto 0;
    display: flex;
    align-items: center;
}

.course-back-button {
    color: #333 !important;
    font-size: 14px;
    font-weight: 500;
}

/* 课程信息区域样式 */
.course-info-wrapper {
    display: flex;
    max-width: 1200px;
    margin: 20px auto;
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;
}

/* 课程封面 */
.course-cover {
    width: 33%;
    margin-right: 20px;
}

.cover-image {
    width: 100%;
    height: auto;
    border-radius: 8px;
}

/* 课程基本信息 */
.course-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

/* 课程标题 */
.course-title {
    font-size: 48px;
    font-weight: bold;
    color: #333;
    margin-bottom: 8px;
}

/* 课程评分 */
.course-rating {
    display: flex;
    align-items: center;
    margin-top: 5px;
}

/* 评分组件 */
.rating {
    margin-right: 10px;
}

/* 评价数量 */
.review-count {
    font-size: 14px;
    color: #999;
}

/* 章节和模拟考试选项卡样式 */
.tabs {
    max-width: 1200px;
    margin: 20px auto;
}

.el-button {
    margin-right: 10px;
}

/* 章节区域样式 */
.chapter-section,
.mock-exam-section {
    max-width: 1200px;
    margin: 20px auto;
}

/* 章节标题栏 */
.chapter-header {
    background-color: #f9f9f9;
    font-size: 18px;
    font-weight: bold;
    padding: 10px 20px;
    border-radius: 5px;
    margin-bottom: 20px;
}

/* 章节列表 */
.chapter-list {
    margin-top: 10px;
}

/* 章节卡片 */
.chapter-col {
    margin-bottom: 20px;
    width: 100%;
}

/* 卡片样式 */
.chapter-card {
    width: 100%;
    border-radius: 5px;
    overflow: hidden;
    transition: box-shadow 0.3s;
    cursor: pointer;
}

/* 鼠标悬浮效果 */
.chapter-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* 章节内容 */
.chapter-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px;
}

/* 章节标题 */
.chapter-title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
}

/* 章节操作区域 */
.chapter-actions {
    display: flex;
    align-items: center;
}

/* 题目完成状态 */
.chapter-status {
    font-size: 14px;
    color: #666;
    margin-right: 15px;
}

/* 开始答题按钮 */
.start-btn {
    margin-left: 5px;
}
</style>
